export const name = 'isEmail';
var Requirements;
(function (Requirements) {
    Requirements[Requirements["MinimumLength"] = 6] = "MinimumLength";
    Requirements[Requirements["MaximumLength"] = 100] = "MaximumLength";
})(Requirements || (Requirements = {}));
/**
 * Determine if value matches criteria to be an email
 *
 * @param value Value to make determination against
 * @param {ErrorMessages} [errorMessages] Custom error messages for each validation
 */
const isEmail = async (value) => {
    const { length } = value.trim();
    if (length < Requirements.MinimumLength || length > Requirements.MaximumLength) {
        return false;
    }
    return !!value.match(/.+@.+\..+/);
};
isEmail.defaultMessage = 'Please provide a valid email.';
export { isEmail };
